export default {
    success: 'Micro-trend was successfully unpinned',
    tooltip: {
        deletable: 'Unpin micro-trend',
        undeletable: 'You can only remove your own micro-trend pins'
    },
    confirm: {
        title: 'Unpin Micro-Trend',
        content: 'Do you also want to delete the relation to the macro-trend {title}?',
        yes: 'Yes, I want to delete the relation',
        no: 'No, I want to keep the relation'
    }
}
